<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='住宿管理' label2="住宿登记" url="/cycle/stay/list"></PageHead>
      <div class="m-portlet__body">
        <!--begin: Form Body -->
        <div class="form-group m-form__group row">
          <label class="col-xl-2 col-form-label m--align-left" style="font-size: 14px;color: #E6A23C;">设置住培生：</label>
          <div class="col-xl-9">
          </div>
        </div>
        <div class="m-form m-form--label-align-right">
          <SearchNormalText v-model='condition.stuname' label='姓名'></SearchNormalText>
          <SearchNormalText v-model='condition.stuno' label='工号'></SearchNormalText>
          <ZPGLSearchDictItemSelect v-model='condition.stuyear' label='届别' :dictid='this.$utils.DictEnum.stuyear'></ZPGLSearchDictItemSelect>
          <ZPGLSearchDictItemSelect v-model='condition.stuspec' label='专业' :dictid='this.$utils.DictEnum.specialty'></ZPGLSearchDictItemSelect>
        </div>
        <div style="clear: both;"></div>
        <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;float: initial;">
          <el-button type="primary" icon="el-icon-search" @click="Search(1)">查询</el-button>
        </div>
        <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
          <el-table ref="multipleTable" v-loading="loading" :data="tableData" tooltip-effect="dark" style="width: 100%"
            @selection-change="handleSelectionChange" row-key="StuID">
            <el-table-column type="selection" width="55" :reserve-selection="true">
            </el-table-column>
            <el-table-column prop="StuName" label="姓名">
            </el-table-column>
            <el-table-column prop="StuNo" label="工号">
            </el-table-column>
            <el-table-column prop="StuYearName" label="届别">
            </el-table-column>
            <el-table-column prop="SpecialityName" label="专业">
            </el-table-column>
          </el-table>
          <div style="margin-top: 10px;text-align: center;" v-if="this.condition.recordCount > 0">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="condition.currentPage"
              :page-sizes="[2, 10, 20, 30, 40]" :page-size="condition.pageSize" layout="total, sizes, prev, pager, next, jumper"
              :total="condition.recordCount">
            </el-pagination>
          </div>
        </div>
        <div class="form-group m-form__group row">
          <label class="col-xl-2 col-form-label m--align-left" style="font-size: 14px;color: #E6A23C;">设置住宿时间：</label>
          <div class="col-xl-9">
          </div>
        </div>
        <el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed" :model="form" ref="form">
          <div class="m-form m-form--label-align-right">
            <div style="float: left;margin-top: 10px;">
              <div class="m-form__group m-form__group--inline">
                <div class="m-form__label">
                  <label style="width: 100px;text-align:right;">开始月份：</label>
                </div>
                <div class="m-form__control">
                  <el-form-item prop="stulivebegindate" :rules="{required: true, message: '开始月份不能为空', trigger: 'blur'}">
                    <el-date-picker v-model="form.stulivebegindate" type="month" placeholder="开始月份" value-format="yyyy-MM"
                      @change="LoadRoom">
                    </el-date-picker>
                  </el-form-item>
                </div>
              </div>
              <div class="d-md-none m--margin-bottom-10"></div>
            </div>
            <div style="float: left;margin-top: 10px;">
              <div class="m-form__group m-form__group--inline">
                <div class="m-form__label">
                  <label style="width: 100px;text-align:right;">结束月份：</label>
                </div>
                <div class="m-form__control">
                  <el-form-item prop="stuliveenddate" :rules="{required: true, message: '结束月份不能为空', trigger: 'blur'}">
                    <el-date-picker v-model="form.stuliveenddate" type="month" placeholder="结束月份" value-format="yyyy-MM">
                    </el-date-picker>
                  </el-form-item>
                </div>
              </div>
              <div class="d-md-none m--margin-bottom-10"></div>
            </div>
            <div style="float: left;margin-top: 10px;">
              <div class="m-form__group m-form__group--inline">
                <div class="m-form__label">
                  <label style="width: 100px;text-align:right;">住宿房间：</label>
                </div>
                <div class="m-form__control">
                  <el-form-item prop="room" :rules="{required: true, message: '住宿房间不能为空', trigger: 'blur'}">
                    <el-select v-model="form.room" filterable placeholder="请选择">
                      <el-option label="请选择" value=""></el-option>
                      <el-option v-for="item in roomOptions" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="d-md-none m--margin-bottom-10"></div>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;float: initial;">
            <el-button type="success" icon="el-icon-s-order" @click="Save" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'StayAdd',
    data() {
      return {
        condition: {
          username: '',
          rolelevel: '',
          secid: '',
          stuname: '',
          stuno: '',
          stuyear: '',
          stuspec: '',
          token: '',
          pageSize: 10,
          currentPage: 1,
          recordCount: 0,
          firstSearch: true
        },
        form: {
          token: '',
          room: '',
          stulivebegindate: '',
          stuliveenddate: '',
          multipleSelection: [],
        },
        roomOptions: [],
        tableData: null,
        idKey: 'StuID',
        fullscreenLoading: false,
        loading: true
      }
    },
    methods: {
      LoadRoom: function(val) {
        var args = {
          token: this.form.token,
          month: val
        }
        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIRoom/ListByMonth', args, function(data) {
          that.roomOptions = []
          for (var i = 0; i < data.Data.length; i++) {
            var peoplenum = data.Data[i]["PeopleNum"] / 1
            var staycount = data.Data[i]["StayCount"] / 1
            var num = peoplenum - staycount
            if (num < 0) {
              num = 0
            }
            var label = data.Data[i]["RoomName"] + '(尚可入住' + num + '人)'
            var arg = {
              value: data.Data[i]["ID"],
              label: label
            }
            that.roomOptions.push(arg)
          }
        }, null, null, null)
      },
      // 调整每页显示数
      handleCurrentChange: function(val) {
        // 改变页的时候调用一次
        this.condition.currentPage = val
        this.Search()
      },
      // 分页操作
      handleSizeChange: function(val) {
        // 改变页的时候调用一次
        this.condition.pageSize = val
        this.condition.currentPage = 1
        this.Search()
      },
      // handleSelectUserChange: function(rows, row) {
      //   var selected = rows.length && rows.indexOf(row) !== -1
      //   if (selected == true) {
      //     this.form.multipleSelection.push(row)
      //   } else {
      //     this.form.multipleSelection.splice(this.form.multipleSelection.indexOf(row), 1);
      //   }
      //   console.log(this.form.multipleSelection)
      // },
      handleSelectionChange: function(val) {
        this.form.multipleSelection = val
      },
      Search: function(index) {
        if (index != null) {
          this.condition.currentPage = 1
        }
        var that = this
        this.$http.post(this.$utils.Url.zpgl + '/api/APIStu/List', this.condition)
          .then(res => {
            if (res.data.Code === 0) {
              that.tableData = res.data.Data
              that.condition.recordCount = res.data.Pager.RecordCount
            } else {
              that.$message({
                message: res.data.Msg + '，' + res.data.Data,
                type: 'error'
              })
            }
            that.loading = false
          })
          .catch(err => {
            that.tableData = null
            that.condition.recordCount = 0
            console.log(err)
            that.$message({
              message: '查询失败',
              type: 'error'
            })
            that.loading = false
          })
      },
      Save: function() {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            if (this.form.multipleSelection.length == 0) {
              this.$message({
                message: '没有选择任何住培生',
                type: 'error'
              })
              return
            }
            if (this.form.stulivebegindate > this.form.stuliveenddate) {
              this.$message({
                message: '住宿开始时间大于结束时间',
                type: 'error'
              })
              return
            }
            this.fullscreenLoading = true
            this.$http.post(this.$utils.Url.zpgl + '/api/APIRoom/RoomRecordAdd', this.form)
              .then(res => {
                if (res.data.Code === 0) {
                  this.$message({
                    message: '保存成功',
                    type: 'success'
                  })
                  console.log('保存成功')
                  this.$router.push('/main/cycle/stay/list')
                } else {
                  this.$message({
                    message: res.data.Msg + '，' + res.data.Data,
                    type: 'error'
                  })
                }
                this.fullscreenLoading = false
              })
              .catch(err => {
                console.log(err)
                this.$message({
                  message: '保存失败',
                  type: 'error'
                })
                this.fullscreenLoading = false
              })
          } else {
            console.log('error submit!!')
            return false;
          }
        })
      }
    },
    mounted: function() {
      this.form.token = sessionStorage.getItem('token')
      this.condition.token = sessionStorage.getItem('token')
      this.condition.username = sessionStorage.getItem('username')
      this.condition.rolelevel = sessionStorage.getItem('rolelevel')
      this.condition.secid = sessionStorage.getItem('secid')
      this.Search()
    }
  }
</script>

<style scoped="scoped">
  .el-form-item {
    margin-bottom: 0px;
  }

  .el-select {
    width: 100%;
  }

  .m-form.m-form--group-seperator-dashed .m-form__group {
    border-bottom: 0;
  }
</style>
